module.exports = __webpack_public_path__ + "img/cb-send-disabled.4d9d781f.svg";